module.exports = __webpack_public_path__ + "static/img/93b86cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/index/开户广告@3x.png
// module id = 640
// module chunks = 2